const FAILED_ID_CHECKS_LIMIT = 3
const USER_ID_STORAGE_KEY = 'user-id'

function isUserMissingIdCheck (user) {
  return Array.isArray(user.missingInfoToSign) &&
    user.missingInfoToSign.includes('idCheck')
}

function canUserSign (user) {
  return user.missingInfoToSign === false
}

/**
 * Mutates a user to remove id check if it's a missingInfoToSign.
 * Does nothing if not an array or idCheck is not missing
 * @param {*} user - The user to mutate
 */
function removeIdCheckFromMissingInfo (user) {
  if (Array.isArray(user.missingInfoToSign)) {
    user.missingInfoToSign.splice(user.missingInfoToSign.indexOf('idCheck'), 1)
    if (user.missingInfoToSign.length === 0) {
      user.missingInfoToSign = false
    }
    // Reset failed id checks. We passed it !
    user.failedIdChecks = 0
  }
}

export {
  canUserSign,
  FAILED_ID_CHECKS_LIMIT,
  isUserMissingIdCheck,
  removeIdCheckFromMissingInfo,
  USER_ID_STORAGE_KEY,
}
